import React from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import type { LucideIcon } from 'lucide-react';
import { connect } from 'react-redux';

export type FancyButtonType = 'Primary' | 'Secondary' | 'Danger' | 'Info';

export interface FancyButtonProp extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    id?: string;
    label: string;
    iconUrl?: string;
    icon?: LucideIcon;
    variant?: FancyButtonType;
    loading?: boolean;
    target: string;
    compact?: boolean;
    reverse?: boolean; // NEW
    clickFunction?: (event: React.MouseEvent) => void;
}

const variantToColorVar = (variant: FancyButtonType = 'Primary') => {
    switch (variant) {
        case 'Secondary': return 'var(--bs-secondary)';
        case 'Danger':    return 'var(--bs-danger)';
        case 'Info':      return 'var(--bs-info)';
        case 'Primary':
        default:          return 'var(--bs-primary)';
    }
};

const FancyButton: React.FC<FancyButtonProp> = ({
                                                    id = 'btn',
                                                    label,
                                                    iconUrl,
                                                    icon: Icon,
                                                    variant = 'Primary',
                                                    loading = false,
                                                    compact = false,
                                                    target,
                                                    reverse = false, // NEW
                                                    className = '',
                                                    disabled,
                                                    type = 'button',
                                                    clickFunction = (e) => { console.log("Please don't kill my vibe"); },
                                                    ...btnProps
                                                }) => {
    const fancyBtn: React.CSSProperties = {
        display: 'inline-grid',
        gridTemplateColumns: reverse ? 'auto 1fr' : '1fr auto', // flip columns
        alignItems: 'center',
        columnGap: 6,
        marginBottom: -10,
        padding: 2,
    };

    const submitting = loading && id == target;
    // Pill padding: bigger padding on the side nearest the circle
    const labelPill: React.CSSProperties = {
        display: 'inline-flex',
        alignItems: 'center',
        padding: reverse ? '4px 10px 4px 22px' : '4px 22px 4px 10px',
        borderRadius: 999,
        background: 'var(--bs-black)',
        color: 'var(--bs-white)',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '0.7rem',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
        justifySelf: reverse ? 'start' : 'end', // hug the circle column
        width: 95,
    };

    const circleStyle: React.CSSProperties = {
        width: compact ? 40 : 60,
        height: compact ? 40 : 60,
        borderRadius: '50%',
        background: variantToColorVar(variant),
        color: 'var(--bs-white)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        flex: '0 0 auto',
        // overlap the circle slightly into the pill
        marginLeft: reverse ? 0 : (compact ? 0 : -25),
        marginRight: reverse ? (compact ? 0 : -25) : 0,
        border: compact ? '0' : 'solid 5px',
    };

    return (
        <Button
            variant="none"
            style={fancyBtn}
            disabled={submitting || disabled}
            onClick={type === 'button' ? clickFunction : undefined}
            type={type}
            {...btnProps}
        >
            {reverse ? (
                <>
          <span style={circleStyle} aria-hidden="true">
            {!submitting && Icon ? (
                iconUrl ? (
                    <img src={iconUrl} style={{ width: 32, height: 32 }} />
                ) : (
                    <Icon size={28} aria-hidden="true" />
                )
            ) : (
                <Spinner animation="border" size="sm" role="status" aria-label="Loading" className="ms-1" />
            )}
          </span>
                    {!compact && (
                        <span style={labelPill}>
              <span style={{ textAlign: 'center', width: 'inherit' }}>{label}</span>
            </span>
                    )}
                </>
            ) : (
                <>
                    {!compact && (
                        <span style={labelPill}>
              <span style={{ textAlign: 'center', width: 'inherit' }}>{label}</span>
            </span>
                    )}
                    <span style={circleStyle} aria-hidden="true">
            {!submitting && Icon ? (
                iconUrl ? (
                    <img src={iconUrl} style={{ width: 32, height: 32 }} />
                ) : (
                    <Icon size={28} aria-hidden="true" />
                )
            ) : (
                <Spinner animation="border" size="sm" role="status" aria-label="Loading" className="ms-1" />
            )}
          </span>
                </>
            )}
        </Button>
    );
};

const mapStateToProps = (state: any) => ({
    loading: state.loaders.submitButton,
    target: state.loaders.target,
});

export default connect(mapStateToProps)(FancyButton);
